
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import _root from './_root.js';

var root = _root;

/** Built-in value references. */
var Symbol = root.Symbol;

var _Symbol = Symbol;

export { _Symbol as default };
//# sourceMappingURL=_Symbol.js.map
